import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  signal,
  WritableSignal,
} from '@angular/core';
import { LegView } from '@sequence/models/view/leg.view';
import { RequestState } from '@shared/models/request-state';
import { Observable } from 'rxjs';
import { OutboundConnectionsView } from './models/outbound-connections.view';
import { OutboundConnectionsService } from './outbound-connections.service';
import { AsyncPipe } from '@angular/common';
import { DurationPipe } from '@shared/pipes/duration.pipe';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
  selector: 'app-outbound-connections',
  standalone: true,
  imports: [AsyncPipe, DurationPipe, FormsModule, SharedModule],
  templateUrl: './outbound-connections.component.html',
  styleUrl: './outbound-connections.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OutboundConnectionsComponent implements OnChanges {
  @Input() flightState?: LegView;

  paxConnections$?: Observable<RequestState<OutboundConnectionsView>>;

  filter: WritableSignal<'all' | 'caution' | 'warning'> = signal('all');

  constructor(private outboundConnectionsService: OutboundConnectionsService) {}

  ngOnChanges(): void {
    this.loadData();
  }

  refresh() {
    this.loadData(true);
  }

  private loadData(isRefresh = false): void {
    if (this.flightState) {
      this.paxConnections$ =
        this.outboundConnectionsService.getOutboundConnections(
          this.flightState,
          isRefresh,
        );
    }
  }
}
